
import { coreAiService } from "./coreService";
import { AiResponse } from "./types";

export const contentGenerationService = {
  async generateTitles(content: string, currentTitle?: string): Promise<AiResponse> {
    // Validate content
    if (!content || content.trim().length === 0) {
      return {
        success: false,
        error: "Cannot generate titles for empty content"
      };
    }

    const systemPrompt = `You are a professional headline writer for a journalistic platform. 
    Generate 5 compelling, varied title options based on the article content.
    Include a mix of styles: informative, engaging, SEO-friendly, question-based, and concise.
    Each title should accurately represent the content while being attention-grabbing.
    Maximum length: 70 characters per title.
    Format as a JSON array of objects with 'title' and 'style' properties.`;

    const prompt = `Generate 5 varied headline options for this article${currentTitle ? ` (current title: "${currentTitle}")` : ''}. 
    The content is about: ${content.substring(0, 1500)}${content.length > 1500 ? '...' : ''}`;

    return coreAiService.generateContent({
      systemPrompt,
      prompt,
      temperature: 0.8,
      maxTokens: 500,
      model: 'gpt-4o-mini',
      content
    });
  },

  async generateLeadParagraph(content: string): Promise<AiResponse> {
    // Validate content
    if (!content || content.trim().length === 0) {
      return {
        success: false,
        error: "Cannot generate lead paragraphs for empty content"
      };
    }

    const systemPrompt = `You are a skilled journalist specializing in writing compelling lead paragraphs.
    Generate 3 alternative lead paragraph options that capture the essence of the article.
    Each lead should include the who, what, when, where, why and how where relevant.
    Aim for 40-60 words per lead. Create different styles: summary-based, narrative, and question-based.
    Format as a JSON array of objects with 'text' and 'style' properties.`;

    const prompt = `Write 3 compelling lead paragraphs for this article. 
    The full content is: ${content}`;

    return coreAiService.generateContent({
      systemPrompt,
      prompt,
      temperature: 0.7,
      maxTokens: 800,
      model: 'gpt-4o-mini',
      content
    });
  }
};
